import React, { useState, useEffect } from "react";

export default function ContactUs() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Responsive styles
  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    padding: windowSize.width < 768 ? "20px" : "40px",
    marginTop: windowSize.width < 768 ? "20px" : "240px",
  };

  const sectionStyle = {
    position: "relative",
    width: "100%",
    maxWidth: "800px",
    padding: windowSize.width < 768 ? "30px 15px" : "50px 20px",
    marginBottom: "30px",
  };

  const headingStyle = {
    textAlign: "center",
    fontSize: windowSize.width < 768 ? "1.8em" : "2.2em",
    marginBottom: "30px",
    color: "#2c3e50",
  };

  const contactCardStyle = {
    backgroundColor: "#f8f9fa",
    borderRadius: "8px",
    padding: "30px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    width: "100%",
  };

  const contactItemStyle = {
    marginBottom: "20px",
    fontSize: windowSize.width < 768 ? "1em" : "1.1em",
    lineHeight: "1.6",
  };

  const labelStyle = {
    fontWeight: "600",
    color: "#3498db",
    marginRight: "10px",
  };

  const mapContainerStyle = {
    width: "100%",
    height: windowSize.width < 768 ? "300px" : "400px",
    borderRadius: "8px",
    border: "none",
  };

  const latitude = 28.6135;
  const longitude = 77.3594;

  // More zoomed-in OpenStreetMap embed URL
  const mapUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${
    longitude - 0.002
  },${latitude - 0.0015},${longitude + 0.002},${
    latitude + 0.0015
  }&layer=mapnik&marker=${latitude},${longitude}`;

  // Larger map link (even higher zoom level)
  const largerMapUrl = `https://www.openstreetmap.org/?mlat=${latitude}&mlon=${longitude}#map=19/${latitude}/${longitude}`;

  return (
    <div style={containerStyle}>
      <section style={sectionStyle}>
        <h1 style={headingStyle}>Contact Us</h1>

        <div style={contactCardStyle}>
          <div style={contactItemStyle}>
            <span style={labelStyle}>Registrar</span>
          </div>

          <div style={contactItemStyle}>
            <span style={labelStyle}>Office:</span>
            Office of Controller of Examinations, JSS University, Noida
          </div>

          <div style={contactItemStyle}>
            <span style={labelStyle}>Address:</span>
            C20/1, Sector-62, Noida, GB Nagar-201301 Uttar Pradesh
          </div>

          <div style={contactItemStyle}>
            <span style={labelStyle}>Phone:</span>
            0120-2401484 (Ext: 214, 262)
          </div>

          <div style={contactItemStyle}>
            <span style={labelStyle}>Email:</span>
            <a
              href="mailto:registrar@jssuninoida.edu.in"
              style={{ color: "#2980b9" }}
            >
              registrar@jssuninoida.edu.in
            </a>
          </div>
        </div>
      </section>

      <section style={{ ...sectionStyle, marginBottom: "50px" }}>
        <div style={contactCardStyle}>
          <h2
            style={{
              ...headingStyle,
              fontSize: windowSize.width < 768 ? "1.5em" : "1.8em",
              marginBottom: "20px",
            }}
          >
            Our Location
          </h2>
          <iframe
            title="JSS University Noida"
            src={mapUrl}
            style={mapContainerStyle}
            allowFullScreen
            loading="lazy"
          ></iframe>
          <br />
          <div style={{ textAlign: "center" }}>
            <small>
              <a
                href={largerMapUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#3498db" }}
              >
                View Larger Map (More Zoomed In)
              </a>
            </small>
          </div>
        </div>
      </section>
    </div>
  );
}
